/* Homepage cart mystery freshener:
   - pulls come from the least popular designs first (window.INC_PICK, see snippets/mystery-pool.liquid)
   - when a freshener leaves the cart its pack can be opened again next time it's earned, same design
   - a new order gets new designs (cart token check in snippets/declutter.liquid) */
(() => {
  const hook = () => {
    const f = window.INCSETCART, X = window.CARTX;
    if (!f || !f.__mr || !X || !window.INCMYS) return setTimeout(hook, 300);
    if (f.__rp) return;
    const w = function () {
      try {
        const m = X.S().g.filter(g => g === 'm').length, R = window.INCMYS(); let ch = false;
        for (let k = 0; k < m; k++) if (!R[k] && window.INC_PICK) { const x = window.INC_PICK(R); if (x) { R[k] = x; ch = true; } }
        for (let k = m; k < R.length; k++) if (R[k] && R[k].seen) { R[k].seen = 0; ch = true; }
        if (ch) localStorage.setItem('inc_mys_v1', JSON.stringify(R));
      } catch (_) {}
      return f.apply(this, arguments);
    };
    w.__mr = 1; w.__rp = 1; window.INCSETCART = w;
  };
  hook();
  // product-page pulls shown in the homepage cart: use the design's photo
  const art = () => { const P = window.INC_POOL || []; document.querySelectorAll('#cnative .cl').forEach(el => { const sm = el.querySelector('small'); if (!sm || !/mystery pull/i.test(sm.textContent)) return; const n = sm.textContent.split(' · ')[0].trim(); const d = P.find(p => p.n === n); const ct = el.querySelector('.ct'); if (!d || !ct) return; const im = ct.querySelector('img'); if (im && im.src === d.s) return; ct.innerHTML = '<img src="' + d.s + '" alt="" loading="lazy">'; }); };
  new MutationObserver(art).observe(document.body, { childList: true, subtree: true });
})();
